/**
 * Comentario section for InspeccionDialog
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Textarea } from '../ui/textarea';
import { FileText } from 'lucide-react';
import VoiceInput from '../VoiceInput';

const ComentarioSection = ({ comentario, onChange, readOnly }) => {
  return (
    <Card className="border-[#E8E8E7]">
      <CardHeader className="pb-3">
        <CardTitle className="text-base sm:text-lg flex items-center justify-between">
          <span className="flex items-center gap-2">
            <FileText size={18} className="text-[#9d8272]" />
            Comentario Adicional (Representante)
          </span>
          {!readOnly && (
            <VoiceInput
              onTranscript={(text, isFinal) => {
                if (isFinal) {
                  onChange(prev => prev ? `${prev} ${text}` : text);
                }
              }}
            />
          )}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Textarea
          value={comentario}
          onChange={(e) => onChange(e.target.value)}
          className={`border-[#c5b8a2] text-sm ${readOnly ? 'bg-gray-50' : ''}`}
          rows={4}
          maxLength={1000}
          placeholder="Ingrese comentarios adicionales o use el micrófono para dictar..."
          readOnly={readOnly}
          data-testid="comentario-textarea"
        />
        <p className="text-[10px] text-[#888888] mt-1 text-right">
          {comentario.length}/1000 caracteres
        </p>
      </CardContent>
    </Card>
  );
};

export default ComentarioSection;
